import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=22bd6d95&scoped=true&"
import script from "./userInfo.vue?vue&type=script&lang=ts&"
export * from "./userInfo.vue?vue&type=script&lang=ts&"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=22bd6d95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd6d95",
  null
  
)

export default component.exports